"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormViewDisplay = void 0;
const lodash_1 = __importDefault(require("lodash"));
const GridConfig_1 = require("./GridConfig");
const dbgate_filterparser_1 = require("dbgate-filterparser");
class FormViewDisplay {
    constructor(config, setConfig, cache, setCache, driver, dbinfo = null, serverVersion = null) {
        this.config = config;
        this.setConfig = setConfig;
        this.cache = cache;
        this.setCache = setCache;
        this.driver = driver;
        this.dbinfo = dbinfo;
        this.serverVersion = serverVersion;
        this.isLoadedCorrectly = true;
        this.dialect = ((driver === null || driver === void 0 ? void 0 : driver.dialectByVersion) && (driver === null || driver === void 0 ? void 0 : driver.dialectByVersion(serverVersion))) || (driver === null || driver === void 0 ? void 0 : driver.dialect);
    }
    addFilterColumn(column) {
        if (!column)
            return;
        this.setConfig(cfg => (Object.assign(Object.assign({}, cfg), { formFilterColumns: [...(cfg.formFilterColumns || []), column.uniqueName] })));
    }
    filterCellValue(column, rowData) {
        if (!column || !rowData)
            return;
        const value = rowData[column.uniqueName];
        const expr = (0, dbgate_filterparser_1.getFilterValueExpression)(value, column.dataType);
        if (expr) {
            this.setConfig(cfg => (Object.assign(Object.assign({}, cfg), { filters: Object.assign(Object.assign({}, cfg.filters), { [column.uniqueName]: expr }), addedColumns: cfg.addedColumns.includes(column.uniqueName)
                    ? cfg.addedColumns
                    : [...cfg.addedColumns, column.uniqueName] })));
            this.reload();
        }
    }
    setFilter(uniqueName, value) {
        this.setConfig(cfg => (Object.assign(Object.assign({}, cfg), { filters: Object.assign(Object.assign({}, cfg.filters), { [uniqueName]: value }) })));
        this.reload();
    }
    removeFilter(uniqueName) {
        const reloadRequired = !!this.config.filters[uniqueName];
        this.setConfig(cfg => (Object.assign(Object.assign({}, cfg), { formFilterColumns: (cfg.formFilterColumns || []).filter(x => x != uniqueName), filters: lodash_1.default.omit(cfg.filters || [], uniqueName) })));
        if (reloadRequired)
            this.reload();
    }
    reload() {
        this.setCache(cache => (Object.assign(Object.assign({}, (0, GridConfig_1.createGridCache)()), { refreshTime: new Date().getTime() })));
    }
    getKeyValue(columnName) {
        const { formViewKey, formViewKeyRequested } = this.config;
        if (formViewKeyRequested && formViewKeyRequested[columnName])
            return formViewKeyRequested[columnName];
        if (formViewKey && formViewKey[columnName])
            return formViewKey[columnName];
        return null;
    }
    requestKeyValue(columnName, value) {
        if (this.getKeyValue(columnName) == value)
            return;
        this.setConfig(cfg => (Object.assign(Object.assign({}, cfg), { formViewKeyRequested: Object.assign(Object.assign(Object.assign({}, cfg.formViewKey), cfg.formViewKeyRequested), { [columnName]: value }) })));
        this.reload();
    }
    extractKey(row) {
        if (!row || !this.baseTable || !this.baseTable.primaryKey) {
            return null;
        }
        const formViewKey = lodash_1.default.pick(row, this.baseTable.primaryKey.columns.map(x => x.columnName));
        return formViewKey;
    }
    cancelRequestKey(rowData) {
        this.setConfig(cfg => (Object.assign(Object.assign({}, cfg), { formViewKeyRequested: null, formViewKey: rowData ? this.extractKey(rowData) : cfg.formViewKey })));
    }
}
exports.FormViewDisplay = FormViewDisplay;
